import { VideoPlayerStyled } from './j-video-player.styled';

interface Props {
  videoUrl: string;
  thumbnailUrl?: string;
  autoHeight?: boolean;
  height?: number;
}

export const JVideoPlayer = ({
  videoUrl,
  thumbnailUrl,
  autoHeight = false,
  height,
}: Props) => {
  return (
    <VideoPlayerStyled
      height={height ?? (autoHeight ? 'auto' : '700px')}
      controls
      poster={thumbnailUrl}
    >
      <source src={videoUrl} type="video/mp4" />
      Your browser does not support the video tag.
    </VideoPlayerStyled>
  );
};
